import React, { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Stack, TextField, Typography } from "@mui/material";

interface Props {
  onSubmit?: (name: string) => void;
  onCancel?: () => void;
  checkIsValidName?: (name: string) => string | null;
}

export const CreateSubAssetClass: React.FC<Props> = ({ onSubmit, onCancel, checkIsValidName }) => {
  const [name, setName] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = () => {
    const isError = checkIsValidName?.(name);
    if (isError) {
      setError(isError);
      return;
    }
    onSubmit?.(name);
  };

  return (
    <Stack
      sx={{
        position: "absolute" as "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        outline: "none",
        width: 460,
        bgcolor: "white",
        p: "32px",
        gap: "20px",
        boxShadow:
          "0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
        borderRadius: "8px"
      }}
    >
      <Stack
        sx={{ flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #DBE8F5", pb: "6px" }}
      >
        <Typography sx={{ color: "#071F35", fontSize: "18px", lineHeight: "24px", fontWeight: 400 }}>
          Add New Sub Asset Class
        </Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <TextField
        label="Sub asses class name"
        error={Boolean(error)}
        helperText={error}
        onChange={(e) => {
          setName(e.target.value);
          if (!error) return;
          setError(null);
        }}
      />
      <Stack sx={{ flexDirection: "row", gap: "12px", justifyContent: "flex-end" }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button disabled={Boolean(error) || !name} variant="contained" startIcon={<AddIcon />} onClick={handleSubmit}>
          Add
        </Button>
      </Stack>
    </Stack>
  );
};
